// @ts-nocheck
// Don't add heavyweight dependencies here
import uuid from 'uuid';
import cookies from 'browser-cookies';

const pageLoadSingletonState = {};

// Must only be called on the client-side
export const setPageLoadSingleton = () => {
  if ('value' in pageLoadSingletonState) {
    return;
  }
  pageLoadSingletonState.value = uuid.v4();
  try {
    if (!sessionStorage.getItem('sessionId')) {
      sessionStorage.setItem('sessionId', uuid.v4());
    }
  } catch (e) {
    return;
  }
  try {
    if (process && process.browser) {
      // get branch cookie from initial page load -- this determines the deploy we're currently hitting
      const branch = cookies.get('branch');
      if (branch) {
        pageLoadSingletonState.branch = branch;
      }
    }
  } catch (e) {
    return;
  }
};

export const getPageLoadSingleton = (): string | undefined => {
  if ('value' in pageLoadSingletonState) {
    return pageLoadSingletonState.value;
  } else {
    return undefined;
  }
};

export const getBranchSingleton = (): string | undefined => {
  if ('branch' in pageLoadSingletonState) {
    return pageLoadSingletonState.branch;
  }
  return undefined;
};
